<svelte:head>
  <title>Create offer | A Good Thing</title>
</svelte:head>

<h2 class="title">Create offer</h2>

<OfferEditor {data} bind:isValid={isValid} />

<div class="columns">
  <div class="column">
<div class="field is-horizontal">
  <div class="field-label">
    <!-- Left empty for spacing -->
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <button
          class="button is-primary"
          class:is-loading={isLoadingFinish}
          disabled={!isValid}
          on:click={() => create(true)}>Finish and review</button>
        &nbsp;
        <button
          class="button"
          class:is-loading={isLoadingSave}
          disabled={!isValid}
          on:click={() => create(false)}>Save for later</button>
      </div>
    </div>
  </div>
</div>
</div>
<div class="column is-3"></div>
</div>

{#if errorMessage}
  <div class="notification is-danger is-light">{errorMessage}</div>
{/if}

<script lang="ts">
  import _ from "lodash";
  import { logging } from '../../../lib/logging';
  import { appState } from "../../../lib/appState";
  import { uiState } from "../../../lib/uiState";
  import { goto, params } from "@sveltech/routify";
  import OfferEditor from "../_components/OfferEditor.svelte";

  let isValid = true;
  let errorMessage : string;
  let isLoadingFinish = false;
  let isLoadingSave = false;
  
  const isLarge = ($params['size'] === 'large');

  let data = {
    name: '',
    description: '',
    status: 'draft' as OfferStatus,
    company: $appState.user!.company!,
    options: {
      nationwide: false,
      divisible: false,
      large: isLarge
    }
  };

  async function create(finish: boolean) {
    if (finish) {
      isLoadingFinish = true;
    } else {
      isLoadingSave = true;
    }

    if(!data.name) {
      data.name = 'Untitled'
    }

    const id = await window.firebase
      .functions()
      .httpsCallable('api-offer-createoffer')({ offer: data } as CreateOfferParams)
      .then((result) => result.data.id)
      .catch((err) => {
        logging.report(err.toString());
        errorMessage = err;
      })
      .finally(() => {
        isLoadingSave = false;
        isLoadingFinish = false;
      });

    if (finish) {
      $goto("../../offer/" + id);
    } else {
      $goto("../../offers/");
    }
  }
</script>
